import { props, reduce, compose, prop, find } from 'ramda';
import COLD_PAGE from '../../config/routes/cold-page';

/**
 * Get all cold page uids.
 * @param {Array} contains a list of cold page with id and slugs for all translations
 * @return list of cold page uids
 */
export const extractColdPageUids = reduce(
  (acc, v) => [...acc, ...props(['fr', 'en'], v)],
  []
);

/**
 * Return the cold page matching uid
 * @param {*} uid
 */
export const getColdPageId = (uid) =>
  compose(
    prop('id'),
    find((v) => {
      return prop('fr', v) === uid || prop('en', v) === uid;
    })
  )(COLD_PAGE);
